import Overlay from '@ynap/overlay';
import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'markdown-to-jsx';
import BEMHelper from '@ynap/bem-helper';
import { Button } from '@ynap/button';

const bem = new BEMHelper('TcOverlay');

const TcOverlay = ({ messages, handleClose, locale, isNewsletterTc }) => {
    const paragraphs = isNewsletterTc ? messages.newsletterTcParagraphs : messages.tcParagraphs;
    const title = isNewsletterTc ? messages.tcOverlay.newsletterTitle() : messages.tcOverlay.title();
    const footer = isNewsletterTc ? messages.tcOverlay.newsletterFooter({ locale: locale.id }) : messages.tcOverlay.footer({ locale: locale.id });
    return (
        <Overlay className={bem('textModal')} onClose={handleClose} handleBodyClick={handleClose}>
            <p>
                {title}
            </p>
            <ul>
                {Object.keys(paragraphs).map((p, i) => (
                    <li key={`tcOverlay-${isNewsletterTc}-${i}`} className={bem(p.includes('-') ? 'subParagraph' : 'paragraph')}>
                        <p>{paragraphs[p]()}</p>
                    </li>
                ))}
            </ul>
            <p id="tcOverlay-footer">
                <ReactMarkdown
                    options={{
                        overrides: {
                            a: {
                                component: Button,
                                props: {
                                    className: bem('link'),
                                    type: 'link',
                                    component: 'a',
                                    target: '_blank',
                                    rel: 'noopener',
                                },
                            },
                        },
                    }}
                >
                    {footer}
                </ReactMarkdown>
            </p>
        </Overlay>
    );
};

TcOverlay.propTypes = {
    handleClose: PropTypes.func,
    isNewsletterTc: PropTypes.bool,
    locale: PropTypes.shape({
        id: PropTypes.string,
    }),
    messages: PropTypes.shape({
        tcOverlay: PropTypes.shape({
            title: PropTypes.func,
            newsletterTitle: PropTypes.func,
            footer: PropTypes.func,
            newsletterFooter: PropTypes.func,
        }),
        tcParagraphs: PropTypes.object,
        newsletterTcParagraphs: PropTypes.object,
    }),
};

export default TcOverlay;
